import React, { useMemo } from 'react';

import { useTranslation } from '@lyearn/i18n';
import { Plus } from '@lyearn/icons';
import { ActionMenu, ActionMenuOverrides } from '@lyearn/molecules';
import { Button } from '@lyearn/ui';

import { AddSurveyBlockProps } from './types';
import { getAddSurveyBlockItems } from './utils';

const OVERRIDES: ActionMenuOverrides = {
  PopoverContent: {
    position: 'bottom',
  },
};

function AddSurveyBlock(props: AddSurveyBlockProps) {
  const { onAddBlock } = props;
  const { t } = useTranslation();
  const items = useMemo(() => getAddSurveyBlockItems(t), [t]);

  return (
    <ActionMenu items={items} minWidth={26.4} overrides={OVERRIDES} onAction={onAddBlock}>
      <Button className="mt-20 self-center" startIcon={<Plus />}>
        {t('SurveyEditor:AddBlock')}
      </Button>
    </ActionMenu>
  );
}

export default AddSurveyBlock;
